import {mapUserDbToType, User} from '@cp/model';
import {onSnapshot} from 'firebase/firestore';
import getUserDocRef from './getUserDocRef';

export default function subscribeUserDoc(
  uid: string,
  onData: (user: User | null) => void,
  onError?: (err: Error) => void,
): () => void {
  const ref = getUserDocRef(uid);
  return onSnapshot(
    ref,
    (snapshot) => {
      try {
        const result = mapUserDbToType(snapshot);
        onData(result ?? null);
      } catch {
        // Firestore may emit an initial snapshot with null serverTimestamp() before the server resolves it
        // (see https://stackoverflow.com/a/47781432). Skip that snapshot and wait for the next one.
        if (snapshot.exists()) {
          return; // ignore this snapshot, wait for resolved timestamps
        }
        // onData(null);
      }
    },
    (err) => onError?.(err),
  );
}
